const filterUbication = ({ ubications, isEditFilter, idUbicationToDelete }) => {
  if (isEditFilter) {
    const editedUbications = ubications.map((location) => {
      if (location.id !== idUbicationToDelete) return location;

      return { ...location, eliminarUbicacion: true };
    });

    return editedUbications;
  }

  const filteredUbications = ubications.filter((location) => location.id !== idUbicationToDelete);

  return filteredUbications || [];
};

const updateLocationData = ({
  ubications,
  ubicationIndex,
  positionNumber,
  lineNumber,
  isEdit,
  plIndex
}) => {
  const ubicationToReturn = ubications;

  // Find the position and line and modify the attribute
  if (isEdit) {
    ubicationToReturn[ubicationIndex].posLines[plIndex].eliminarPosicionLinea = true;

    return ubicationToReturn;
  }

  ubicationToReturn[ubicationIndex].posLines = ubicationToReturn[ubicationIndex].posLines.filter(
    (positionLine) =>
      !(positionLine.numeroLinea === lineNumber && positionLine.numeroPosicion === positionNumber)
  );

  return ubicationToReturn;
};

const getIndexUbiaction = ({ ubications, values }) =>
  ubications.findIndex((loc) => {
    if (loc.isOyM) {
      return (
        loc.nombre === values?.ubication?.ubication?.nombre &&
        loc.idOperacion === values?.ubication?.uunn?.id &&
        loc.ubicacionTecnica?.idInstalacion === values?.ubication?.installation?.id
      );
    }

    // todo: check EYM locations with different eventoPozoId and different team, but same remaining data
    return (
      loc.nombre === values?.ubication?.ubication?.nombre &&
      loc.idUnidadNegocio === values?.ubication?.uunn?.id &&
      loc.tipoUbicacionEnum === values?.ubication?.ubicationType?.id &&
      loc.idEvento === values?.ubication?.event?.id &&
      loc.idLocacion === values?.ubication?.ubication?.id
    );
  });

const addPosLinesWithOutRepetition = ({ currentPosLines, newPosLines }) => {
  const posLines = currentPosLines.concat(newPosLines);

  const positionLineMap = new Map(
    posLines.map((posLine) => [`${posLine.numeroPosicion}-${posLine.numeroLinea}`, posLine])
  );

  const posLinesWithOutRepetition = Array.from(positionLineMap, ([_, value]) => value);

  return posLinesWithOutRepetition;
};

export { filterUbication, updateLocationData, getIndexUbiaction, addPosLinesWithOutRepetition };
